<span class="mt-5 justify-content-center align-items-center" appDottedLoader [appShowLoaderUntil]="activeApplicationTiles"></span>
<div *ngFor="let activeApplicationTile of activeApplicationTiles" class="section mt-4 p-5 d-flex flex-column justify-content-center align-items-center font-small font-sm-normal">
  <ng-container *ngIf="!activeApplicationTile.nonRetail">
    <p class="heading font-medium font-sm-larger" [innerHtml]="activeApplicationTile.status"></p>
    <div>
      <p>We are processing your application and are working to find the best offer for you.</p>
    </div>
    <div>
      <button *ngIf="activeApplicationTile.action && activeApplicationTile.redirectRoute" mat-flat-button [routerLink]=[activeApplicationTile.redirectRoute] class="primary mt-4 mr-4">
        {{activeApplicationTile.action}}
      </button>
      <button *ngIf="activeApplicationTile.loanSuggestedTermAction && activeApplicationTile.loanSuggestedTermRoute" mat-flat-button [routerLink]=[activeApplicationTile.loanSuggestedTermRoute] class="primary mt-4">
        {{activeApplicationTile.loanSuggestedTermAction}}
      </button>
    </div>
  </ng-container>
</div>
